"use client"
import styled from "@emotion/styled"
import { Box, Button } from "@mui/material"
import { RentProjectVisualizationItem } from "utils/projects"
import { useFilters } from "../FilterContext"

type Props = RentProjectVisualizationItem

const StyledItem = styled.div`
  --item-black: #011727;
  border-radius: 8px;
  padding: 16px;
  background-color: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(2.5px);
  width: 100%;
  text-align: center;
  color: var(--item-black);

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  ${(props) => props.theme.breakpoints.up("lg")} {
    bottom: 16px;
  }
`

const StyledTextContent = styled.div`
  h3 {
    font-size: 20px;
    font-weight: 700;
    line-height: 150%;
    margin: 0;
  }
  p {
    margin: 0;

    font-size: 16px;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: -0.32px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    h3 {
      font-size: 32px;
      margin-block-end: 4px;
    }
    p {
      font-size: 20px;
      letter-spacing: -0.4px;
    }
  }
`

const StyledButton = styled(Button)`
  border-radius: 8px;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0px;
  padding: 8px 24px;
  --theme-color: ${(props) => props.theme.colors.blue4rentMarketing};
  color: white;
  background-color: var(--theme-color);
  border-color: var(--theme-color);

  &:hover {
    background-color: ${(props) => props.theme.colors.blue4rentMarketingHover};
  }
`

const ProjectVisualizationItem = ({ button, text, title, buildingName }: Props) => {
  const btn = button?.[0]
  const { setState } = useFilters()

  const handleButtonClick = (e: React.MouseEvent) => {
    e.preventDefault()

    // Apply the filter
    if (buildingName) {
      setState((prev) => ({
        ...prev,
        buildingNames: [buildingName],
      }))
    }

    // Handle scrolling
    if (btn?.url) {
      setTimeout(() => {
        const targetId = btn.url?.replace("#", "")
        if (targetId) {
          const targetElement = document.getElementById(targetId)

          if (targetElement) {
            targetElement.scrollIntoView({ behavior: "smooth", block: "start" })
          }
        }
      }, 50)
    }
  }

  return (
    <StyledItem>
      <StyledTextContent>
        <h3>{title}</h3>
        <p>{text}</p>
      </StyledTextContent>
      {btn?.url && (
        <Box
          sx={{
            cursor: "pointer",
            position: "relative",
          }}
          onClick={handleButtonClick}
          style={{
            textDecoration: "none",
          }}
        >
          <StyledButton variant="contained">{btn?.name}</StyledButton>
        </Box>
      )}
    </StyledItem>
  )
}
export default ProjectVisualizationItem
